import React, { useEffect, useState } from 'react'
import AgencyManagerScheduleDetailsManagement from './AgencyManagerScheduleDetailsManagement'
import { useLocation } from 'react-router-dom'
import ModalWarn from '../../Components/Modal/Warn/index'

export default function AgencyManagerScheduleDetails(props) {
  const [successMsg, setSuccessMsg] = useState('')
  const [loadRegionalManager, setLoadRegionalManager] = useState(false)
  const [erroMsg, setErroMsg] = useState([])
  const [orgaoScheduleList, setOrgaoScheduleList] = useState([])
  const [loadingButton, setLoadingButton] = useState(false)
  const [modalInvalidSessionError, setModalInvalidSessionError] = useState(false)
  const [modalInvalidSessionErrorTitle, setModalInvalidSessionErrorTitle] = useState(null)
  const [modalInvalidSessionErrorMsg, setModalInvalidSessionErrorMsg] = useState(null)

  const location = useLocation()
  const { result_search } = location.state
  const [regionalManager, setRegionalManager] = useState({
    cpf: result_search.CPF_USUARIO,
    id_usuario_orgao: result_search.ID_USUARIO_ORGAO,
    name: result_search.NOME_USUARIO,
    organ: { value: result_search.CODIGO_ORGAO, label: result_search.NOME_ORGAO },
    units: [{}],
    dias_semana: result_search.DIAS_SEMANA,
    hora_inicio: result_search.HORA_INICIO,
    hora_fim: result_search.HORA_FIM,
    data_limite: result_search.DATA_LIMITE,
    motivo: result_search.MOTIVO_HORARIO_EXCECAO,
  })

  useEffect(() => {
    async function loadUserUnits() {
      const user = JSON.parse(localStorage.getItem('user'))
      const requestOptions = {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          authorization: user ? user.token : '',
          'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
        }),
        body: JSON.stringify({
          cpf_gestor: user.cpf_atendente,
          id_usuario_orgao: regionalManager.id_usuario_orgao,
          codigo_orgao: user.codigo_orgao,
        }),
      }
      await fetch(`${process.env.REACT_APP_API_URL}/gestao/listaUnidadesDoUsuarioPorIdUsuOrg`, requestOptions)
        .then(function (response) {
          if (response.ok) {
            response.json().then(function (data) {
              // CONSUMIU O BACKEND BALCAO COM SUCESSO !!!!
              var unitList = [];
              data.unidades.forEach((unit) => {
                unitList.push({
                  value: unit.CODIGO_UNIDADE,
                  label: unit.NOME_UNIDADE
                });
            });
              setRegionalManager({...regionalManager, units: unitList})
            })
          } else if (response.status === 422) {
            response.json().then(function (data) {
              if (!!data.errorCode && !!data.message) {
                // inserir a mensagem: data.message no aviso de erro
                console.log(data.message)
              } else {
                // inserir mensagem genérica
                console.log('Response error in gestao/listaUnidadesDoUsuarioPorIdUsuOrg BackendBalcao')
              }
            })
          } else if (response.status === 403) {
            response.json().then(function (data) {
              setModalInvalidSessionErrorTitle(data.title ? data.title : null)
              setModalInvalidSessionErrorMsg(data.message ? data.message : null)
              setModalInvalidSessionError(true)
            })
          } else {
            // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
            //setLoading(false);
            //setModalError(true);
            console.log('Request error in gestao/listaUnidadesDoUsuarioPorIdUsuOrg BackendBalcao')
          }
        })
        .catch(function (err) {
          console.error('Failed retrieving information', err)
        })
    }
    async function loadDefaultOrganSchedule() {
      const user = JSON.parse(localStorage.getItem('user'))
      const requestOptions = {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          authorization: user ? user.token : '',
          'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
        }),
        body: JSON.stringify({
          cpf_gestor: user.cpf_atendente,
          codigo_orgao: user.codigo_orgao,
        }),
      }
      await fetch(`${process.env.REACT_APP_API_URL}/gestao/horario/consultaHorarioOrgao`, requestOptions)
        .then(function (response) {
          if (response.ok) {
            response.json().then(function (data) {
              setOrgaoScheduleList(data);
            })
          } else if (response.status === 422) {
            response.json().then(function (data) {
              if (!!data.errorCode && !!data.message) {
                // inserir a mensagem: data.message no aviso de erro
                console.log(data.message)
              } else {
                // inserir mensagem genérica
                console.log('Response error in gestao/detalhaGestorRegional BackendBalcao')
              }
            })
          } else if (response.status === 403) {
            response.json().then(function (data) {
              setModalInvalidSessionErrorTitle(data.title ? data.title : null)
              setModalInvalidSessionErrorMsg(data.message ? data.message : null)
              setModalInvalidSessionError(true)
            })
          } else {
            // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
            //setLoading(false);
            //setModalError(true);
            console.log('Request error in gestao/detalhaGestorRegional BackendBalcao')
          }
        })
        .catch(function (err) {
          console.error('Failed retrieving information', err)
        })
    }

    loadUserUnits();
    loadDefaultOrganSchedule()
    setLoadRegionalManager(true)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function confirmUpdate() {
    setLoadingButton(true)
    const user = JSON.parse(localStorage.getItem('user'))

    const requestOptions = {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json',
        authorization: user ? user.token : '',
        'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
      }),

      body: JSON.stringify({
        cpf_gestor: user.cpf_atendente,
        codigo_orgao: regionalManager.organ.value,
        id_usuario_orgao: regionalManager.id_usuario_orgao,
        cpf_gestor_regional: regionalManager.cpf,
        dias_semana: regionalManager.dias_semana,
        hora_inicio: regionalManager.hora_inicio,
        hora_fim: regionalManager.hora_fim,
        data_limite: regionalManager.data_limite,
        motivo_horario_excecao: regionalManager.motivo,
      }),
    }

    await fetch(`${process.env.REACT_APP_API_URL}/gestao/horario/editaHorarioGestorRegional`, requestOptions)
      .then(function (response) {
        if (response.ok) {
          response.json().then(function (data) {
            setSuccessMsg(data.message)
            setErroMsg(undefined)
          })
        } else {
          response.json().then(function (data) {
            setErroMsg(data.message)
            console.log('Erro no request de /gestao/horario/editaHorarioGestorRegional')
          })
        }
      })
      .catch(function (err) {
        console.error('Failed retrieving information', err)
      })
    setLoadingButton(false)
    window.scrollTo(0,0)
  }

  return (
    <>
      <ModalWarn
          id='modalWarnalertInvalidSession'
          appear={modalInvalidSessionError}
          title = { modalInvalidSessionErrorTitle }
          text={ modalInvalidSessionErrorMsg ? modalInvalidSessionErrorMsg : 'Este acesso foi transferido para outro dispositivo.'}
          textButton2='Ir para tela inicial'
          actionButton2={() => { 
              document.getElementById("btnLogout").click();
          }}
      />
      <AgencyManagerScheduleDetailsManagement
        pageTitle='Horário de exceção do gestor regional'
        regionalManager={regionalManager}
        setRegionalManager={setRegionalManager}
        loadOperator={loadRegionalManager}
        buttonBackRoute='/horarios'
        buttonEditRoute='/editarHorarioOrgao'
        confirmUpdate={confirmUpdate}
        orgaoScheduleList={orgaoScheduleList}
        history={props.history}
        erroMsg={erroMsg}
        fromSuccessMsg={successMsg}
        loadingButton={loadingButton}
      />
    </>
  )
}
